import sessionTokenStorage from "@/constants/SessionTokenStorage";
import type { AxiosInstance } from "axios";

/**
 * Generic function to configure the token interceptor.
 * @param apiInstance AxiosInstance for the specific microservice.
 */
export const configureTokenInterceptor = (apiInstance: AxiosInstance) => {
  apiInstance.interceptors.request.use(
    async (config) => {
      console.log("[Request Interceptor] Outgoing request:");
      console.log("URL:", config.url);
      console.log("Method:", config.method);
      console.log("Headers:", config.headers);
      console.log("Params:", config.params);
      console.log("Data:", config.params);
      console.dir(config.data, { depth: Number.POSITIVE_INFINITY });

      if (!config.url?.includes("/welcome")) {
        const token = sessionTokenStorage.getToken();

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};
